<mat-chip-list>
  <ng-container *ngFor="let item of items">
    <mat-chip>
      {{ displayText(item) }}
      <mat-icon matChipRemove (click)="remove(item)">cancel</mat-icon>
    </mat-chip>
  </ng-container>
</mat-chip-list>
